module.exports = __webpack_public_path__ + "fontawesome-webfont.acf3dcb7ff752b5296ca.svg";


//////////////////
// WEBPACK FOOTER
// E:/Git_new/IVMS_PRO/web/src/assets/icon/font-awesome/fonts/fontawesome-webfont.svg?v=4.7.0
// module id = ../../../../../src/assets/icon/font-awesome/fonts/fontawesome-webfont.svg?v=4.7.0
// module chunks = styles